(function () {
  function getRemainingTime(deadline) {
    var total = deadline - new Date().getTime();

    if (isNaN(total)) {
      return false;
    }

    var seconds = Math.floor((total / 1000) % 60);
    var minutes = Math.floor((total / 1000 / 60) % 60);
    var hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    var days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
      total: total,
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  }

  function addLeadingZeros(time) {
    return ('0' + time).slice(-2);
  }

  function updateSingleClock(countdown) {
    var deadlineValue = countdown.getAttribute('data-deadline');

    if (!deadlineValue) return;

    var deadline = new Date(deadlineValue).getTime();
    var remainingTime = getRemainingTime(deadline);

    if (!remainingTime) return;

    var daysSpan = countdown.querySelector('.js-days');
    var hoursSpan = countdown.querySelector('.js-hours');
    var minutesSpan = countdown.querySelector('.js-minutes');
    var secondsSpan = countdown.querySelector('.js-seconds');
    var expiredText = countdown.querySelector('.expired');

    if (remainingTime.total <= 0) {
      if (expiredText) {
        expiredText.classList.add('show');
      }

      if (daysSpan) daysSpan.innerText = '00';
      if (hoursSpan) hoursSpan.innerText = '00';
      if (minutesSpan) minutesSpan.innerText = '00';
      if (secondsSpan) secondsSpan.innerText = '00';

      countdown.setAttribute('data-expired', 'true');
      return;
    }

    if (daysSpan) daysSpan.innerText = addLeadingZeros(remainingTime.days);
    if (hoursSpan) hoursSpan.innerText = addLeadingZeros(remainingTime.hours);
    if (minutesSpan) minutesSpan.innerText = addLeadingZeros(remainingTime.minutes);
    if (secondsSpan) secondsSpan.innerText = addLeadingZeros(remainingTime.seconds);
  }

  function updateAllCountdowns() {
    var countdowns = document.querySelectorAll('.js-countdown-time');

    countdowns.forEach(function (countdown) {
      updateSingleClock(countdown);
    });

    var activeCountdowns = document.querySelectorAll('.js-countdown-time:not([data-expired="true"])');

    if (activeCountdowns.length === 0) {
      clearInterval(window.hokCountdownInterval);
      window.hokCountdownInterval = null;
    }
  }

  function initCountdowns() {
    if (window.hokCountdownInterval) {
      clearInterval(window.hokCountdownInterval);
    }

    updateAllCountdowns();
    window.hokCountdownInterval = setInterval(updateAllCountdowns, 1000);
  }

  document.addEventListener('DOMContentLoaded', initCountdowns);

  document.addEventListener('shopify:section:load', function () {
    initCountdowns();
  });
})(); 
 
 
 
 // var deadline = new Date("2026-07-10T23:59:59").getTime();

  // function getRemainingTime(deadline) {
  //   var total = deadline - new Date().getTime();

  //   if (isNaN(total)) {
  //     return false;
  //   }

  //   var seconds = Math.floor((total / 1000) % 60);
  //   var minutes = Math.floor((total / 1000 / 60) % 60);
  //   var hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  //   var days = Math.floor(total / (1000 * 60 * 60 * 24));

  //   return {
  //     total: total,
  //     days: days,
  //     hours: hours,
  //     minutes: minutes,
  //     seconds: seconds
  //   };
  // }

  // function addLeadingZeros(time) {
  //   return ('0' + time).slice(-2);
  // }

  // function updateClock() {
  //   var remainingTime = getRemainingTime(deadline);
  //   var countdowns = document.querySelectorAll('.js-countdown');

  //   if (!remainingTime) {
  //     return false;
  //   }

  //   countdowns.forEach(function (countdown) {
  //     var daysSpan = countdown.querySelector('.js-days');
  //     var hoursSpan = countdown.querySelector('.js-hours');
  //     var minutesSpan = countdown.querySelector('.js-minutes');
  //     var secondsSpan = countdown.querySelector('.js-seconds');
  //     var expiredText = countdown.querySelector('.expired');

  //     if (remainingTime.total <= 0) {
  //       if (expiredText) {
  //         expiredText.classList.add('show');
  //       }

  //       if (daysSpan) daysSpan.innerText = '00';
  //       if (hoursSpan) hoursSpan.innerText = '00';
  //       if (minutesSpan) minutesSpan.innerText = '00';
  //       if (secondsSpan) secondsSpan.innerText = '00';

  //       return;
  //     }

  //     if (daysSpan) daysSpan.innerText = addLeadingZeros(remainingTime.days);
  //     if (hoursSpan) hoursSpan.innerText = addLeadingZeros(remainingTime.hours);
  //     if (minutesSpan) minutesSpan.innerText = addLeadingZeros(remainingTime.minutes);
  //     if (secondsSpan) secondsSpan.innerText = addLeadingZeros(remainingTime.seconds);
  //   });

  //   if (remainingTime.total <= 0) {
  //     clearInterval(interval);
  //   }
  // }

  // updateClock();
  // var interval = setInterval(updateClock, 1000);